import { defineComponent as _defineComponent } from 'vue'
import { toRefs, computed, inject, onMounted, nextTick } from 'vue'
import { Base } from '@/generated-clients/myGeo'
import { Account } from '@/generated-clients/myProfile'
import { Device, MaintenanceItem, MaintenanceItemType } from '@/generated-clients/myTrips'
import IconCalender from '@components/icons/icon-calender.svg'
import { LoadState } from '@/utils/types'


export default /*#__PURE__*/_defineComponent({
  __name: 'CarHealthBookAppointmentButton',
  props: {
    maintenanceItem: null,
    vehicleId: null
  },
  setup(__props: any) {

const props = __props as {
  maintenanceItem: MaintenanceItem,
  vehicleId: number
}



// store getter mappings
const store = inject('vuex-3-store') as any
const account = computed(() => store.getters['Profile/getAccount'] as Account)

const shoudLoadAccount = computed(() => store.getters['Profile/getAccountStatus'] === LoadState.None)

const activeBase =  computed(() => store.getters['Favorite/getActiveBase'] as Base)
const shouldLoadActiveBase =  computed(() => store.getters['Favorite/getActiveBaseStatus'] === LoadState.None)

const shouldLoadStations = computed(() => store.getters["Favorite/getStationsStatus"] === LoadState.None)

const recommendedBase = computed(() => store.getters["Favorite/getRecommendedBase"] as Base)
const shoudLoadRecommendedBase = computed(() => store.getters["Favorite/getRecommendedBaseStatus"] === LoadState.None)

const userAddressProvince = computed(() => store.getters['Geographics/getMostRelevantPlaceProvince'] as string)
const shouldLoadAutoCompletePlaces = computed(() => store.getters['Geographics/getAutocompletePlacesStatus'] === LoadState.None)

// store action mappings
const fetchAccountDetails = async () => store.dispatch('Profile/fetchAccountDetails')
const fetchActiveOeamtcBase = async () => store.dispatch('Favorite/fetchActiveOeamtcBase')
const fetchStations = async () => store.dispatch('Favorite/fetchStations')
const fetchRecommendedBase = async (lat?: number, lon?: number) => store.dispatch('Favorite/fetchRecommendedBase', { lat, lon })
const fetchAutocompletePlaces = async (address: string) => store.dispatch('Geographics/fetchAutocompletePlaces', { search: address })
const getSlugifiedBaseName = (baseName: string) => (store.getters['Favorite/getSlugifiedBaseName'] as (val: string) => string)(baseName)

const { maintenanceItem, vehicleId } = toRefs(props)

const province = computed(() => (activeBase.value?.address?.county || userAddressProvince.value)?.toLowerCase())

const appointmentBookingUrl = computed(() => {
  const pathContext = slugifiedBaseName.value ? `/${slugifiedBaseName.value}` : ''
  const pathParams = {
    "bundesland" : province.value || null,
    "kfzid" : vehicleId.value != null ? vehicleId.value : null
  }
  const pathParamPairs = Object.entries(pathParams).filter(([, val]) =>  val != null && val !== '')
  const path = pathParamPairs.map(([key, val]) => `${key}=${val}`).join('&')
  const restPath = `${pathContext}?${path}`
  switch (maintenanceItem.value.itemType) {
    case MaintenanceItemType.Oil:
      return `/termine/sicherheits-ueberpruefung${restPath}`
    case MaintenanceItemType.P57a:
      return `/termine/57a-begutachtung${restPath}`
    case MaintenanceItemType.WinterTire:
      return `/termine/raederwechsel${restPath}`
    default:
      return '/tvg2#/user'
  }
})

const userAddressFormatted = computed(() => {
  const address = account.value?.address
  return address ? `${address.street} ${address.streetNumber}, ${address.zip} ${address.city}, ${address.country}` : ''
})

const lastKnownDeviceLocation = computed(() => {
  const device = store.getters['Triplog/getDevice'] as Device
  return device?.lastKnownLocation
})

const slugifiedBaseName = computed(() => {
  if (activeBase.value) {
    return getSlugifiedBaseName(activeBase.value.name)
  } else if (recommendedBase.value){
    return getSlugifiedBaseName(recommendedBase.value.name)
  } else {
    return ""
  }
})

onMounted(async () => {
  if (shouldLoadActiveBase.value) {
    fetchActiveOeamtcBase()
  }
  if (shouldLoadStations.value) {
    fetchStations()
  }
  if (shoudLoadRecommendedBase.value) {
    fetchRecommendedBase(lastKnownDeviceLocation.value?.latitude, lastKnownDeviceLocation.value?.longitude)
  }
  if (shoudLoadAccount.value) {
    await fetchAccountDetails()
    await nextTick()
  }
  if (userAddressFormatted.value && shouldLoadAutoCompletePlaces.value) {
    fetchAutocompletePlaces(userAddressFormatted.value)
  }
})


return { __sfc: true,props, store, account, shoudLoadAccount, activeBase, shouldLoadActiveBase, shouldLoadStations, recommendedBase, shoudLoadRecommendedBase, userAddressProvince, shouldLoadAutoCompletePlaces, fetchAccountDetails, fetchActiveOeamtcBase, fetchStations, fetchRecommendedBase, fetchAutocompletePlaces, getSlugifiedBaseName, maintenanceItem, vehicleId, province, appointmentBookingUrl, userAddressFormatted, lastKnownDeviceLocation, slugifiedBaseName, IconCalender }
}

})